import { ReactElement, useCallback, useState } from 'react';
import Image from '@/components/LocalImage';
import SignModel from '@/components/SignModel';
import Menu, { MenuProps } from './Menu';
import JoinUs from './JoinUs';
import styles from '@/styles/pages/home/home.module.less';
import MiniShade from '@/components/MiniShade';
import React from 'react';
import { getHomeSectionPath, homeMenu } from '@/services/menu';
import { useNavigate } from 'react-router-dom';
import SandboxModal from '../sandbox-modal/SandboxModal';
import AiComponent from '@/components/ai/AiComponent';
import WalletMenu from './WalletMenu';

const Headers = React.forwardRef((props: MenuProps, ref): ReactElement => {
    const [showoverlay, setShowoverlay] = useState(false);
    const { onChangeMenu } = props;
    const history = useNavigate();

    const __onChangeMenu = useCallback((currentIndex: number) => {
        setShowoverlay(false);
        if (currentIndex === 4) {
            const w = window.open('about:blank');
            if (w) {
                w.location.href = 'https://aicade-galaxy.gitbook.io/white-paper';
            }
            return;
        }
        if (currentIndex === 5) {
            history('/admin/home');
            return;
        }
        history(getHomeSectionPath(currentIndex));
        onChangeMenu && onChangeMenu(currentIndex);
    }, []);

    const __children = [] as ReactElement[];
    homeMenu.forEach((e) => {
        __children.push(
            <li key={e.index} onClick={() => __onChangeMenu(e.index)}>
                {e.name}
            </li>
        );
    });

    const miniMenu = <ul>{__children}</ul>;

    return (
        <div className={styles['headers']}>
            <div className={styles['header-content']}>
                <div className={styles['logo-style']}>
                    <Image name="logo" dir="/images/home" type="svg" width="164" height="20" />
                </div>
                <div>{<Menu onChangeMenu={onChangeMenu} ref={ref} />}</div>
                <div>{<JoinUs />}</div>
            </div>
            <SignModel />
            <div className={styles['header-mini']}>
                <MiniShade showoverlay={showoverlay}>{miniMenu}</MiniShade>
                <div onClick={() => setShowoverlay(true)}>
                    <Image name="menu-icon" dir="/images/mobile" type="svg" width="40" height="40" />
                </div>
                <div className={styles['header-mini-title']}>Alcade Galaxy</div>
            </div>
            <WalletMenu />
            <SandboxModal />
            <AiComponent />
        </div>
    );
});

export default Headers;
